var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, HStack, Text, VStack } from "native-base";
import { useTranslation } from "@madmedical/i18n";
import ActionButton from "../ActionButton";
import Badge from "../../atoms/Badge";
const RepresentativeListItem = (_a) => {
    var { onResendPress, onEditPress, onDeletePress } = _a, item = __rest(_a, ["onResendPress", "onEditPress", "onDeletePress"]);
    const { t } = useTranslation();
    return (_jsxs(HStack, Object.assign({ justifyContent: "space-between", alignItems: "center", bgColor: "white", minWidth: "full", borderBottomWidth: 1, borderColor: "gray.100", px: 4, py: 5 }, { children: [_jsxs(VStack, { children: [_jsxs(HStack, Object.assign({ space: 1.5, mb: 1 }, { children: [_jsx(Text, { children: item.nameOrEmail }), _jsx(Badge, Object.assign({ size: "sm", variant: `ghost${item.status ? "Success" : "Warning"}` }, { children: item.status ? t("active") : t("invited") }))] })), item.note && (_jsx(Text, Object.assign({ color: "gray.600", fontSize: "xs" }, { children: item.note })))] }), _jsx(Box, Object.assign({ ml: "auto" }, { children: _jsx(ActionButton, { actions: [
                        ...(!item.status
                            ? [
                                {
                                    text: t("resendEmail"),
                                    iconName: "mailAll",
                                    onPress: () => {
                                        onResendPress(item);
                                    },
                                },
                            ]
                            : []),
                        {
                            text: t("edit"),
                            iconName: "edit",
                            onPress: () => {
                                onEditPress(item);
                            },
                        },
                        {
                            text: t("delete"),
                            iconName: "trashCan",
                            onPress: () => {
                                onDeletePress(item);
                            },
                        },
                    ] }) }))] })));
};
export default RepresentativeListItem;
